import * as types from '../mutation-types'
import { api } from './../../modules/api'

const state = () => ({
  types: [],
  totalItems: 0,
  totalPages: 0
})

const getters = { getVIPAttendeeTypes: state => state.types }

const actions = {
  async fetchVIPAttendeeTypes ({commit}, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      const { data } = await this.$axios.get(api.vipAttendeeType.get(payload))
      commit(types.SET_VIP_ATTENDEE_TYPES, data)
      return data
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE)
    }
    commit(types.SET_SPINNER_STATUS, false)
  }
}

const mutations = {
  [types.SET_VIP_ATTENDEE_TYPES] (state, data) {
    state.types = data.attendeeTypes
    state.totalItems = data.totalItems
    state.totalPages = data.totalPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vipAttendeeType.js